export default function VariablePanel() {

    const variables = [
        "{{guest_first_name}}",
        "{{guest_last_name}}",
        "{{tour_name}}",
        "{{guide_name}}",
        "{{start_datetime}}",
        "{{total_price}}"
    ];

    return (

        <div>

            <h4>Available Variables</h4>

            {variables.map(v=>(
                <div key={v}>
                    {v}
                </div>
            ))}

        </div>

    );

}